import { pointToProjection } from '@/services/pluginsManager/map/fitBounds/fitBounds.utils';
import { Feature } from 'ol';
import { LineString } from 'ol/geom';
import { MapSize } from '@/redux/map/map.types';

export const SNAP_GRID_RESOLUTION = 20;
export const SNAP_GRID_PIXEL_TOLERANCE = 20;
export const DEFAULT_SNAP_GRID_PIXEL_TOLERANCE = 5;

export function getSnapFeature(mapSize: MapSize): Feature[] {
  const features: Feature[] = [];
  for (let x = 0; x < mapSize.width; x += SNAP_GRID_RESOLUTION) {
    features.push(
      new Feature(
        new LineString([
          pointToProjection({ x, y: 0 }, mapSize),
          pointToProjection({ x, y: mapSize.height }, mapSize),
        ]),
      ),
    );
  }
  for (let y = 0; y < mapSize.height; y += SNAP_GRID_RESOLUTION) {
    features.push(
      new Feature(
        new LineString([
          pointToProjection({ x: 0, y }, mapSize),
          pointToProjection({ x: mapSize.width, y }, mapSize),
        ]),
      ),
    );
  }

  return features;
}
